import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { MainStateProvider } from 'contexts/MainStateContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MainStateProvider>
        
        <App />
        
      </MainStateProvider>
    </BrowserRouter>
  </React.StrictMode>
);


reportWebVitals();